import { ButtonContainer, HintText, IconButton } from "./CopySignatureButton.styles";

type CopySignatureButtonProps = {
  onClick: () => void;
  status?: "idle" | "success" | "error";
};

export const CopySignatureButton = ({ onClick, status = "idle" }: CopySignatureButtonProps) => {
  const helperText =
    status === "success"
      ? "Copiado com sucesso"
      : status === "error"
        ? "Falha ao copiar"
        : "Use o ícone para copiar";

  return (
    <ButtonContainer>
      <HintText $status={status}>{helperText}</HintText>
      <IconButton
        type="button"
        onClick={onClick}
        aria-label="Copiar assinatura"
        title="Copiar assinatura"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M9 9H5C3.9 9 3 9.9 3 11V19C3 20.1 3.9 21 5 21H13C14.1 21 15 20.1 15 19V15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 3H11C9.9 3 9 3.9 9 5V13C9 14.1 9.9 15 11 15H19C20.1 15 21 14.1 21 13V5C21 3.9 20.1 3 19 3Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </IconButton>
    </ButtonContainer>
  );
};